import React, { useState, useRef, useEffect } from 'react';
import { useTypingAnimation } from '../../../hooks/useTypingAnimation';

const Hero = ({ onOpenAuthModal }) => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef(null);
  const typedText = useTypingAnimation([
    'Learn.', 'Code.', 'Speak.', 'Create.', 'Build.', 'Explore.'
  ]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleCanPlay = () => setVideoLoaded(true);
      const handleError = handleVideoError;

      video.addEventListener('canplay', handleCanPlay);
      video.addEventListener('error', handleError);

      return () => {
        video.removeEventListener('canplay', handleCanPlay);
        video.removeEventListener('error', handleError);
      };
    }
  }, []);

  const handleVideoError = () => {
    console.log('Video failed to load, using fallback background');
    setVideoLoaded(true);
    const videoContainer = document.querySelector('.hero-video-container');
    if (videoContainer) {
      videoContainer.style.background = 'var(--gradient-mixed)';
    }
  };

  return (
    <section className="hero" id="home">
      {/* Video Background Container */}
      <div className="hero-video-container">
        {!videoLoaded && (
          <div className="video-loading" id="videoLoading">
            <div className="loading-spinner"></div>
          </div>
        )}
        
        <video 
          ref={videoRef}
          className="hero-video" 
          autoPlay 
          muted 
          loop 
          playsInline
          preload="metadata"
          aria-hidden="true"
        >
          {/*<source src="/videos/nature1.mp4" type="video/mp4" />*/}
          <source src="/videos/AmalikaWorldVideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      
      {/* Video Overlay */}
      <div className="hero-overlay"></div>
      
      {/* Hero Content */}
      <div className="hero-content">
        <h1 className="hero-title">Unlock Your Potential<br />with<br />AMALIKA WORLD</h1>
        <p className="hero-subtitle">A future-ready school for language learning, robotics, and coding.</p>
        <div className="typing-container">
          <div className="typing-text">
            <span>{typedText}</span>
            <span className="cursor"></span>
          </div>
        </div>
        <div className="hero-buttons">
          <a href="#programs" className="btn btn-primary" role="button">
            <i className="fas fa-rocket" aria-hidden="true"></i>
            Explore Our Programs
          </a>
          <button 
            className="btn btn-secondary" 
            onClick={() => onOpenAuthModal('login')}
            role="button"
          >
            <i className="fas fa-sign-in-alt" aria-hidden="true"></i>
            Login Portal
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;